export default __webpack_public_path__ + "static/media/190629_190332_IMG_3426.c3ad1618.jpg";